module.exports = __webpack_public_path__ + "img/itemico2.57af22c6.png";